import React from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "routes/routes.js";
import { useAuth } from "context/AuthContext";

function Admin() {
  const [sidenavOpen, setSidenavOpen] = React.useState(true);
  const location = useLocation();
  const mainContentRef = React.useRef(null);
  const { role, isAuthenticated } = useAuth();

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContentRef.current) {
      mainContentRef.current.scrollTop = 0;
    }
  }, [location]);

  /* ================= ROUTES ================= */

  const getRoutes = (routes, role) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views, role);
      }

      if (prop.layout === "/admin") {
        const hasAccess = prop.roles.includes(role);
        return (
          <Route
            path={prop.path}
            key={key}
            element={
              isAuthenticated && hasAccess ? (
                prop.component
              ) : (
                <Navigate to="/" />
              )
            }
          />
        );
      }
      return null;
    });
  };

  /* ================= FIND CURRENT ROUTE ================= */

  const getCurrentRoute = (routes) => {
    for (let i = 0; i < routes.length; i++) {
      const route = routes[i];

      if (route.collapse) {
        const found = getCurrentRoute(route.views);
        if (found) return found;
      }

      if (
        route.layout &&
        location.pathname.includes(route.layout + route.path)
      ) {
        return route;
      }
    }
    return null;
  };

  const currentRoute = getCurrentRoute(routes);

  /* ================= NAVBAR VISIBILITY ================= */

  const showAdminNavbar = currentRoute?.path !== "/dashboard";

  /* ================= UI HELPERS ================= */

  const toggleSidenav = () => {
    if (document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-pinned");
      document.body.classList.add("g-sidenav-hidden");
    } else {
      document.body.classList.add("g-sidenav-pinned");
      document.body.classList.remove("g-sidenav-hidden");
    }
    setSidenavOpen(!sidenavOpen);
  };

  const getBrandText = () => {
    return currentRoute?.name || "Dashboard";
  };

  const getNavbarTheme = () => {
    return location.pathname.includes("alternative-dashboard")
      ? "light"
      : "dark";
  };

  /* ================= RENDER ================= */

  return (
    <>
      <Sidebar
        routes={routes}
        toggleSidenav={toggleSidenav}
        sidenavOpen={sidenavOpen}
        logo={{
          innerLink: "/",
          imgSrc: require("assets/img/brand/argon-react.png"),
          imgAlt: "...",
        }}
      />

      <div className="main-content" ref={mainContentRef}>
        <AdminNavbar
          theme={getNavbarTheme()}
          toggleSidenav={toggleSidenav}
          sidenavOpen={sidenavOpen}
          brandText={getBrandText()}
        />

        <Routes>
          {getRoutes(routes, role)}
          <Route
            path="*"
            element={<Navigate to="/admin/dashboard" replace />}
          />
        </Routes>
      </div>

      {sidenavOpen && (
        <div className="backdrop d-xl-none" onClick={toggleSidenav} />
      )}
    </>
  );
}

export default Admin;
